import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// import Init from "./Init";
import "fonts/Merriweather-Black.ttf";
import "fonts/Merriweather-Bold.ttf";
import "fonts/Merriweather-Regular.ttf";
import "fonts/OpenSans-Bold.ttf";
import "fonts/OpenSans-SemiBold.ttf";
import "fonts/OpenSans-Regular.ttf";
import "styles/index.styles.css";

ReactDOM.render(<App />, document.querySelector("#root"));
// ReactDOM.render(<Init />, document.querySelector("#root"));
